import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import api from "../lib/api";

export default function AdSlot({ placement, city, district, category, className = "" }) {
  const [ads, setAds] = useState([]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const p = new URLSearchParams({ placement });
    if (city) p.set("city", city);
    if (district) p.set("district", district);
    if (category) p.set("category", category);
    api.get(`/ads?${p.toString()}`).then((r) => setAds(r.data)).catch(() => {});
  }, [placement, city, district, category]);

  useEffect(() => {
    if (ads.length < 2) return;
    const t = setInterval(() => setIndex((i) => (i + 1) % ads.length), 4000);
    return () => clearInterval(t);
  }, [ads.length]);

  if (!ads.length) return null;
  const ad = ads[index % ads.length];
  const track = (id) => api.post(`/ads/${id}/click`).catch(() => {});

  return (
    <div className={`relative overflow-hidden rounded-2xl border border-white/10 ${className}`} data-testid={`ad-banner-slot-${placement}`}>
      <a
        key={ad.id}
        href={ad.url || "#"}
        {...(ad.url?.startsWith("http") ? { target: "_blank", rel: "noreferrer" } : {})}
        onClick={() => track(ad.id)}
        data-testid={`ad-item-${ad.id}`}
        className="block relative w-full h-44 sm:h-64 group"
      >
        <img src={ad.image} alt={ad.name} className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-700" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#070C1E]/95 via-[#070C1E]/20 to-transparent" />
        <span className="absolute top-3 right-3 text-[10px] font-bold tracking-widest bg-black/60 text-slate-300 rounded px-2 py-0.5">SPONSORLU</span>
        <div className="absolute bottom-4 left-5 right-5">
          <div className="text-white font-extrabold text-lg sm:text-2xl drop-shadow-lg">{ad.name}</div>
        </div>
      </a>
      {ads.length > 1 && (
        <>
          <button type="button" data-testid={`ad-prev-${placement}`} aria-label="Önceki reklam"
            onClick={() => setIndex((i) => (i - 1 + ads.length) % ads.length)}
            className="absolute left-3 top-1/2 -translate-y-1/2 p-2 rounded-full bg-black/50 border border-white/10 text-slate-200 hover:text-[#D4AF37] hover:border-[#D4AF37]/50 transition-colors">
            <ChevronLeft size={18} />
          </button>
          <button type="button" data-testid={`ad-next-${placement}`} aria-label="Sonraki reklam"
            onClick={() => setIndex((i) => (i + 1) % ads.length)}
            className="absolute right-3 top-1/2 -translate-y-1/2 p-2 rounded-full bg-black/50 border border-white/10 text-slate-200 hover:text-[#D4AF37] hover:border-[#D4AF37]/50 transition-colors">
            <ChevronRight size={18} />
          </button>
          <div className="absolute bottom-3 right-4 flex gap-1.5">
            {ads.map((a, i) => (
              <button key={a.id} type="button" aria-label={`Reklam ${i + 1}`} onClick={() => setIndex(i)}
                className={`h-1.5 rounded-full transition-all ${i === index % ads.length ? "w-6 bg-[#D4AF37]" : "w-1.5 bg-white/40"}`} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
